import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {useSelector} from "../Redux";
import { useTranslation } from 'react-i18next'
import { GetState, GetStateFromData } from './CustomHooks/CustomHooks';

function Timer(props) {

    const { t } = useTranslation(['styles', 'translation']);
    
    const {initialMinute=0, initialSeconds=0, close} = props;
    const [minutes, setMinutes] = useState(initialMinute);
    const [seconds, setSeconds] =  useState(initialSeconds);
 
    const contexts = GetStateFromData(props.containerId);
    
    const {globalTime, setGlobalTime,  sessionPopupTime, sessionTime,  formBuillderMode, builderMode}=contexts.contexts;

    useEffect(()=>{
        let myInterval;
        if(builderMode === "application"){
            myInterval = setInterval(()=>{
                if(globalTime.sec > 0) {
                    setGlobalTime({...globalTime , sec:globalTime.sec - 1});
                }
                if(globalTime.sec === 0) {
                    if(globalTime.min === 0) {
                        clearInterval(myInterval);
                    } else {
                        setGlobalTime({...globalTime , min:globalTime.min-1 ,sec:59});
                    }
                }
            }, 1000);
        }
        
        return () => {
            clearInterval(myInterval);
        }
    });

  

    return(
        
        <div
            style = {props.style}
        >  
            {
               props.global ? null :
                <> {minutes < 10 ? `0${minutes}` : minutes }:{seconds < 10 ? `0${seconds}` : seconds } </>

            }
        </div>
    )
}

export default Timer


 


